import { StatementStatus } from 'app/dataTypes/cafeteria/compensation/statements'

import styles from './Status.scss'


const getStatusDescription = (status: StatementStatus) => {
  if (status === StatementStatus.Draft) return 'Черновик'
  if (status === StatementStatus.Approved) return 'Проведена'
  if (status === StatementStatus.Consideration) return 'На рассмотрении'
  if (status === StatementStatus.Processing) return 'В обработке'
  if (status === StatementStatus.Denied) return 'Отказано'
  if (status === StatementStatus.Deleted) return 'Удалена'
  if (status === StatementStatus.Canceled) return 'Отменено проведение'
  return 'Неизвестный статус'
}

type Props = {
  ID: string
  status: StatementStatus
}

export const Status = ({
  ID,
  status,
}: Props) => {
  const statusDescription = getStatusDescription(status)

  return (
    <div className={styles.root}>
      <div className={styles.indicator}>
        <div className={styles.circle} />
      </div>

      <div className={styles.id}>{ID}</div>

      <div className={styles.status}>
        <div>{statusDescription}</div>
      </div>
    </div>
  )
}
